import INVENTORY_API_BASE_URL from "../../config/api";
import "./assets.css";
import { useState, useEffect } from "react";
import Axios from "axios";
import Button from "react-bootstrap/Button";
import swal from "sweetalert";
import moment from "moment";

function Assets() {
  const [listOfAssets, setlistOfAssets] = useState([]);
  const [Assets, setAssets] = useState("");
  const [Description, setDescription] = useState("");
  const [Category, setCategory] = useState("");
  const [assetsTag, setassetsTag] = useState("");
  const [Serialno, setSerialno] = useState("");
  const [Invoiceno, setInvoiceno] = useState("");
  const [InvFile, setInvFile] = useState("");
  const [Suppliername, setSuppliername] = useState("");
  const [Date, setDate] = useState("");
  const [Quantity, setQuantity] = useState("");
  const [price, setprice] = useState("");
  const [selectedDate, setSelectedDate] = useState("");
  const [totalValue, setTotalValue] = useState(0);
  const maxDate = moment().format("YYYY-MM-DD");

  const createUser = () => {
    const formData = new FormData();
    formData.append("Assets", Assets);
    formData.append("Description", Description);
    formData.append("Category", Category);
    formData.append("assetsTag", assetsTag);
    formData.append("Serialno", Serialno);
    formData.append("Invoiceno", Invoiceno);
    formData.append("InvFile", InvFile);
    formData.append("Suppliername", Suppliername);
    formData.append("Date", Date);
    formData.append("Warranty", selectedDate);
    formData.append("Quantity", Quantity);
    formData.append("price", price);

    Axios.post(`${INVENTORY_API_BASE_URL}/postAssets`, formData)
      .then(() => {
        setlistOfAssets([
          ...listOfAssets,
          {
            Assets,
            Description,
            Category,
            assetsTag,
            Serialno,
            Invoiceno,
            InvFile,
            Suppliername,
            Date,
            Warranty: selectedDate,
            Quantity,
            price,
          },
        ]);
        swal({
          title: "Assets Created",
          text: "",
          icon: "success",
        });
      })
      .catch((error) => {
        console.error("Error creating assets:", error);
      });
  };

  const handleDateChange = (event) => {
    setSelectedDate(event.target.value);
  };

  const calculateTotalValue = () => {
    const quantity = parseInt(Quantity, 10) || 0;
    const assetPrice = parseFloat(price) || 0;
    const total = quantity * assetPrice;
    setTotalValue(total.toFixed(2)); 
  };

  useEffect(() => {
    calculateTotalValue();
  }, [Quantity, price]);

  return (
    <div className="assetform-container">
      <h6 className="assets"> </h6>
      <br />
      <form>
        <h5>Create Asset</h5>
        <h6>Asset Name : </h6>
        <input
          type="text"
          name="Assets"
          required="required"
          onChange={(event) => {
            setAssets(event.target.value);
          }}
        />
        <h6>Asset Description : </h6>
        <input
          type="text"
          name="Description"
          onChange={(event) => {
            setDescription(event.target.value);
          }}
        />
        <h6>Category : </h6>
        <input
          type="text"
          name="Category"
          onChange={(event) => {
            setCategory(event.target.value);
          }}
        />
        <h6>Asset Label : </h6>
        <input
          type="text"
          name="assetslabel"
          onChange={(event) => {
            setassetsTag(event.target.value);
          }}
        />
        <h6>Serial Number : </h6>
        <input
          type="text"
          name="Serialno"
          onChange={(event) => {
            setSerialno(event.target.value);
          }}
        />
        <h6>Invoice Number : </h6>
        <input
          type="text"
          name="Invoiceno"
          onChange={(event) => {
            setInvoiceno(event.target.value);
          }}
        />
        <h6>Upload Invoice : </h6>
        <input
          type="File"
          name="file"
          onChange={(e) => setInvFile(e.target.files[0])}
        />
        <h6>Supplier Name : </h6>
        <select
          name="suppliername"
          onChange={(event) => {
            setSuppliername(event.target.value);
          }}
        >
          <option value="">Select Supplier</option>
          <option value="Flipkart">Flipkart</option>
          <option value="Amazon">Amazon</option>
          <option value="Other">Other</option>
        </select>
        <h6>Purchase Date : </h6>
        <input
          type="date"
          max={maxDate}
          onChange={(e) => {
            setDate(e.target.value);
          }}
        />
        <h6>Warranty Expiry Date : </h6>
        <input
          type="date"
          value={selectedDate}
          onChange={handleDateChange}
        />{" "}
        <h6>Quantity : </h6>
        <input
          type="text"
          name="Quantity"
          onChange={(event) => {
            setQuantity(event.target.value);
          }}
        />
        <h6>Price : </h6>
        <input
          type="text"
          name="price"
          onChange={(event) => {
            setprice(event.target.value);
          }}
        />
        <h6>Value : </h6>
        <span>{totalValue}</span>
        <Button className="btnass" type="submit" onClick={createUser}>
          Save
        </Button>
      </form>
      <br />
    </div>
  );
}

export default Assets;
